import { getEnvConfig } from 'utils/getEnvConfig'
import {
  apiRequestInterceptor,
  apiResponseErrorInterceptor,
  apiResponseSuccessInterceptor
} from './apiInterceptor'
import ApiService from './ApiService'

const BUSINESS_TYPES_ENDPOINT = '/v2.0/business-types'

const headers = {
  'content-type': 'application/json',
  accept: 'application/json, text/plain, */*'
}

const api = new ApiService(`${getEnvConfig('WEB_BASE_URL')}/identity/legacy`, headers)

api.requestInterceptor(apiRequestInterceptor, (error: any) => console.error(error))
api.responseInterceptor(apiResponseSuccessInterceptor, apiResponseErrorInterceptor)

export const getBusinessTypes = () => {
  return api.getRequest(BUSINESS_TYPES_ENDPOINT, {})
}

export const MerchantApiV2 = {
  getBusinessTypes
}
